export const NAME = "core/init";

export interface InitState {
    initialized: boolean;
}

export const initialState: InitState = {
    initialized: false,
};
